<template>
    <div class="container lnb d_container">
        <div class="contents_wrap">
            <div class="contents list-container">
                <div class="title">
                    테스트관리
                </div>
                <div class="info_text mb20">
                    테스트 이미지는 296 x 296 사이즈에 최적화 되어 있습니다. <br>
                    저장 버튼을 눌러야 해당 항목이 반영됩니다.
                </div>
                <div class="list-content">

                    <level-test-component></level-test-component>
                </div>
            </div>
            <div class="footer-copyright">Copyright 2021. Peopleandtalk co.,Ltd. All rights reserved</div>
        </div>
    </div>
</template>

<script>
import LevelTestComponent from "@/components/level/LevelTestComponent";
export default {
    name: "LevelTest",
    mixins: [],
    components: {LevelTestComponent},
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {},
    watch: {},
}
</script>

<style scoped>

</style>
